import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { icons, IconText } from '../../../generic';
import type { NotificationUserType } from '../../../../../shared/settings/project/notifications';

const userTypeToIconTextMap = {
  current: <IconText icon={icons.user} text="Only me" />,
  all: <IconText icon={icons.globe} text="Organization" />,
  custom: <IconText icon={icons.cog} text="Custom" />,
};

type Props = {
  isDisabled: boolean;
  userType: NotificationUserType;
  onSelect: (userType: NotificationUserType) => void;
};

/**
 * SelectUsersButton is a dropdown button for selecting the users to notify.
 */
const SelectUsersButton: VoidFunctionComponent<Props> = ({
  isDisabled,
  userType,
  onSelect,
}) => (
  <DropdownButton
    id="notification-user-type-dropdown"
    title={userTypeToIconTextMap[userType]}
    onSelect={(selectedUserType: NotificationUserType) => onSelect(selectedUserType)}
    disabled={isDisabled}
  >
    <MenuItem eventKey="current">{userTypeToIconTextMap.current}</MenuItem>
    <MenuItem eventKey="all">{userTypeToIconTextMap.all}</MenuItem>
    <MenuItem eventKey="custom">{userTypeToIconTextMap.custom}</MenuItem>
  </DropdownButton>
);

export default SelectUsersButton;
